module.exports = __webpack_public_path__ + "img/phone_iphone-light.5cb1c401.svg";